




































import Vue from 'vue';
import Component from 'vue-class-component';
import { AuthenticationModuleState } from '../types';
import { mapState } from 'vuex';
import { ErrorMessages } from '../services/userService';

@Component({
  computed: {
    ...mapState<AuthenticationModuleState>('authenticationModule', {
      localUser: (state: AuthenticationModuleState) => state.localUser,
      authenticationError: (state: AuthenticationModuleState) => state.error
    })
  },
  // TAB: Can't use @Prop decorator for props that are set by the router
  props: {
    signUp: Boolean
  }
})
export default class Register extends Vue {
  public email: string | null = null;
  public password: string | null = null;
  public username: string | null = null;
  public signUpMode = false;

  public mounted() {
    this.signUpMode = this.$props.signUp;
  }

  public toggleMode(): void {
    this.signUpMode = !this.signUpMode;
    this.$store.dispatch('authenticationModule/clearError');
  }

  public onLogIn(): void {
    this.$store.dispatch(
      'authenticationModule/logIn',
      {
        email: this.email,
        password: this.password
      }
    ).then(() => {
      this.$router.push({ path: '/' });
    }).catch((reason: Error) => {
      if (reason.message !== ErrorMessages.invalidCredentials) {
        throw reason;
      }
    });
  }

  public onSignUp(): void {
    this.$store.dispatch(
      'authenticationModule/signUp',
      {
        email: this.email,
        password: this.password,
        username: this.username
      }
    ).then(() => {
      this.$router.push({ path: '/' });
    }).catch((reason: Error) => {
      if (reason.message !== ErrorMessages.usernameTaken &&
        reason.message !== ErrorMessages.emailTaken) {
        throw reason;
      }
    });
  }
}

